import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { api } from "../lib/api";
import { eventPublicPath } from "../lib/eventLinks";

export default function LegacyEventRedirect() {
  const { eventId } = useParams();
  const nav = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const r = await api.get(`/events/${eventId}`);
        if (cancelled) return;
        const path = r.data?.public_path || eventPublicPath(r.data);
        if (path) {
          nav(path, { replace: true });
          return;
        }
        setError("Event not found.");
      } catch {
        if (!cancelled) setError("Event not found.");
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [eventId, nav]);

  return (
    <div className="min-h-[40vh] flex items-center justify-center bg-canvas px-4">
      <p className="font-display text-[18px] text-plum">{error || "Redirecting…"}</p>
    </div>
  );
}
